// Book Appointment Form slider
$(".book-appointment-best-sellers").slick({
  slidesToShow: 4.4,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 3.4,
      },
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
});
$(".book-appointment-diamond-shapes").slick({
  slidesToShow: 5.4,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 4.4,
      },
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 4,
      },
    },
  ],
});
$("body").addClass("show-cart-loader");
$(document).ready(function () {
  //  Range slider code
  var price = "500,40000";
  var carat = "0.5,10";
  var filterArray = [{ price }, { carat }];
  if (theme.get_local_storage("appointment-form")) {
    filterArray = JSON.parse(theme.get_local_storage("appointment-form"));
  }
  function store_default_diamond_filter() {
    console.log(filterArray);
    localStorage.setItem("appointment-form", JSON.stringify(filterArray));
  }
  function update_min_max_attribute(
    start_input,
    start_val,
    end_input,
    end_val,
    min = 0,
    max = 0
  ) {
    start_input.attr("data-value", start_val);
    end_input.attr("data-value", end_val);
    if (min) {
      start_input.attr("data-min", min);
    }
    if (max) {
      end_input.attr("data-max", max);
    }
  }

  function slide_stop_n_change_event(
    has_input,
    start_input,
    end_input,
    filter_array_place,
    filter_array_name,
    filter_array_type,
    handle,
    value1,
    value2
  ) {
    console.log(
      "slide_stop_n_change_event",
      value1,
      value2,
      handle,
      filter_array_name
    );
    if (filter_array_type == "array") {
      const number_array = [];
      for (var i = value1; i < value2; i++) {
        number_array.push(Math.round(i));
      }
      filterArray[filter_array_place][filter_array_name] = number_array;
    } else {
      filterArray[filter_array_place][filter_array_name] =
        value1 + "," + value2;
    }
    if (has_input) {
      update_min_max_attribute(start_input, value1, end_input, value2);
    }
    store_default_diamond_filter();
  }
  function current_filter_setting(
    filter_array_place,
    filter_array_name,
    filter_array_type
  ) {
    if (filter_array_type == "text") {
      return filterArray[filter_array_place][filter_array_name].split(",");
    } else {
      const current_fitler = filterArray[filter_array_place][filter_array_name];
      return [current_fitler[0], current_fitler[current_fitler.length - 1] + 1];
    }
  }
  // Initialize range slider on load
  function diamond_range_slider(
    selector,
    min,
    max,
    step,
    has_input,
    start_input,
    end_input,
    filter_array_place,
    filter_array_name,
    filter_array_type
  ) {
    var array_value = current_filter_setting(
      filter_array_place,
      filter_array_name,
      filter_array_type
    );
    if (filter_array_name === "price") {
      noUiSlider.create(selector, {
        start: [array_value[0], array_value[1]],
        connect: true,
        range: {
          min: [min, 1],
          "30%": [2000, 100],
          "70%": [10000, 500],
          "90%": [50000, 1000],
          max: [max],
        },
      });
    } else if (filter_array_name === "carat") {
      noUiSlider.create(selector, {
        start: [array_value[0], array_value[1]],
        connect: true,
        range: {
          min: [min, 0.01],
          "40%": [1, 0.05],
          "80%": [10, 0.5],
          max: [max],
        },
      });
    } else {
      // console.log(filter_array_name, array_value[0], array_value[1], min, max);
      noUiSlider.create(selector, {
        start: [array_value[0], array_value[1]],
        connect: true,
        margin: step,
        range: { min: min, max: max },
        step: step,
      });
    }
    if (has_input) {
      selector.noUiSlider.on("update", function (values, handle) {
        //   console.log(values,handle)
        if (filter_array_name === "price") {
          start_input.val("$" + Math.round(values[0]));
          end_input.val("$" + Math.round(values[1]));
          // return false;
        } else if (filter_array_name == "carat") {
          start_input.val(values[0] + " Ct.");
          end_input.val(values[1] + " Ct.");
          // return false;
        } else if (filter_array_name == "lwratio") {
          start_input.val(values[0]);
          end_input.val(values[1]);
        } else {
          start_input.val(Math.round(values[0]));
          end_input.val(Math.round(values[1]));
        }
        update_min_max_attribute(
          start_input,
          values[0],
          end_input,
          values[1],
          min,
          max
        );
      });
    }
    selector.noUiSlider.on("set", function (values, handle) {
      // console.log('rahul')
      slide_stop_n_change_event(
        has_input,
        start_input,
        end_input,
        filter_array_place,
        filter_array_name,
        filter_array_type,
        handle,
        values[0],
        values[1]
      );
    });
  }
  var diamond_price_slider = $("#diamonds-price-slider")[0];
  var diamond_carat_slider = $("#diamonds-carat-slider")[0];
  if (diamond_price_slider) {
    diamond_range_slider(
      diamond_price_slider,
      100,
      700000,
      100,
      true,
      $("#slide-min-price"),
      $("#slide-max-price"),
      0,
      "price",
      "text"
    );
  }
  if (diamond_carat_slider) {
    diamond_range_slider(
      diamond_carat_slider,
      0.25,
      20.3,
      0.04,
      true,
      $("#slide-min-carat"),
      $("#slide-max-carat"),
      1,
      "carat",
      "text"
    );
  }

  //   Day calculator
  var calculator = {
    workDaysAdded: 0,
    month: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ],
    monthFull: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    weekday: ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"],
    weekdayFull: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    curDate: null,
    getNewWorkDay: function (daysToAdd) {
      this.curDate = new Date(daysToAdd);
      return [
        this.curDate.getDate(),
        this.monthFull[this.curDate.getMonth()]
      ];
    },
  };
  function shipping_work_day(appointment_date = "") {
    try {
      var appointment_day = appointment_date.split("T");
      var newWorkDay = calculator.getNewWorkDay(appointment_day[0]);
      console.log("appointment_date",appointment_day)
      console.log("newWorkDay",newWorkDay);
      $(".image-overlay-content p strong").text(`
        ${newWorkDay[1]} ${newWorkDay[0]},${appointment_day[0].split("-")[0]} 
        at ${appointment_day[1].split(":")[0]}:${appointment_day[1].split(":")[1]} EST`
      );
    } catch (e) {}
  }
  var url_search_params = new URLSearchParams(window.location.href);
  var customer_name = url_search_params.get("invitee_full_name");
  var appointment_date = url_search_params.get("event_start_time");
  shipping_work_day(appointment_date);
  $(".appointment-name").text(customer_name);

  function input_value(selector) {
    var list_array = [];
    selector.find(".radio-item").each(function () {
      var input_field = $(this).find("input");
      if (input_field.prop("checked")) {
        list_array.push(input_field.val());
      }
    });
    console.log(list_array);
    return list_array.toString();
  }

  function load_content_after_form_submission() {
    $(".book-appointment-form-section").hide();
    $("h1").text("Thank you!");
    $(".image-overlay-content p").text(
      "Your preferences have been submitted. We look forward to seeing you."
    );
    setTimeout(function () {
      $("body").removeClass("show-cart-loader");
    }, 1000);
  }

  if (theme.get_local_storage("jotform")) {
    load_content_after_form_submission();
  } else {
    $("body").removeClass("show-cart-loader");
  }

  $(".book-appointment-form .btn-wrapper button").on("click", function () {
    $("body").addClass("show-cart-loader");
    var product_tyope = url_search_params.get("answer_1");
    var u_id = url_search_params.get("event_type_uuid");
    var price_range = `${$("#slide-min-price").val()}-${$(
      "#slide-max-price"
    ).val()}`;
    var diamond_shapes = input_value($(".book-appointment-diamond-shapes"));
    var ring_settings = input_value($(".book-appointment-best-sellers"));
    var diamond_type = input_value($(".diamond-type-input"));
    var carat_range = `${$("#slide-min-carat").val()} - ${$(
      "#slide-max-carat"
    ).val()}`;
    var diamond_cuts = input_value($(".diamond-cuts-type"));
    var diamond_colors = input_value($(".diamond-colors-type"));
    var diamond_clarities = input_value($(".diamond-claritie-type"));
    var additional_information = $(".input-field textarea").val();
    var formData = new FormData();
    formData.append("submission[47]", u_id);
    formData.append("submission[48]", customer_name);
    formData.append("submission[31]", price_range);
    formData.append("submission[33]", diamond_shapes);
    formData.append("submission[34]", ring_settings);
    formData.append("submission[36]", diamond_type);
    formData.append("submission[40]", carat_range);
    formData.append("submission[37]", diamond_cuts);
    formData.append("submission[41]", diamond_colors);
    formData.append("submission[43]", diamond_clarities);
    formData.append("submission[44]", additional_information);

    var url =
      "https://api.jotform.com/form/240222640487452/submissions?apiKey=0512ed4e566c7d7fb1b3aa923d9edc44";

    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success:", data);
        theme.set_local_storage("jotform", "submitted");
        load_content_after_form_submission();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    console.log(
      u_id,
      price_range,
      diamond_shapes,
      ring_settings,
      diamond_type,
      carat_range,
      diamond_cuts,
      diamond_colors,
      diamond_clarities,
      additional_information
    );
  });

  // Iterating the search parameters
  for (var p of url_search_params) {
    console.log(p);
  }

  // Set Best seller products selection limit
  $("input.input-radio").on("change", function (evt) {
    if (
      $(".book-appointment-best-sellers input.input-radio:checked").length > 3
    ) {
      this.checked = false;
    }
  });

  // Grey out other options on hover
  $(".diamond-type-input .radio-item, .diamond-attribute .radio-item").hover(
    function () {
      $(this).siblings().css("opacity", 0.4);
    },
    function () {
      $(this).siblings().css("opacity", 1);
    }
  );
});
